import $ from 'jquery';

$(function () {
  var $fiveStarRewardsCheckbox = $('#company_five_star_rewards');

  var selectStar = function (fiveStarsSelected) {
    var $selected = fiveStarsSelected
      ? $('#js-5-star-on')
      : $('#js-5-star-off');
    var $unselected = fiveStarsSelected
      ? $('#js-5-star-off')
      : $('#js-5-star-on');

    $fiveStarRewardsCheckbox.prop('checked', fiveStarsSelected);

    $selected.removeClass('far');
    $selected.addClass('fas');
    $unselected.addClass('far');
    $unselected.removeClass('fas');
  };

  $('#js-5-star-on').on('click', function () {
    selectStar(true);
  });
  $('#js-5-star-off').on('click', function () {
    selectStar(false);
  });

  selectStar($fiveStarRewardsCheckbox.prop('checked'));
});
